import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { AdmissionsAreaService } from '../admissions-area.service';
import { AdmissionsEngagementsService } from './admissions-engagements.service';
import { AdmissionsEngagementsTab1Part } from './tabs/tab-1/admissions-engagements-tab-1.part';
import { AdmissionsEngagementsTab2Part } from './tabs/tab-2/admissions-engagements-tab-2.part';
import { AdmissionsEngagementsViewsPart } from './views/engagements-views.part';


@Component({
	selector: 'admissions-engagements-page',
	standalone: true,
	imports: [
		AdmissionsEngagementsTab1Part,
		AdmissionsEngagementsTab2Part,
		AdmissionsEngagementsViewsPart,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		TrimesterDroplistWidget,
		DroplistWidget,
		ToolbarWidget,
		PageTabsWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './admissions-engagements.page.html',
})
export class AdmissionsEngagementsPage implements OnInit {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Admissions;
	public admissionsService = inject(AdmissionsAreaService);

	constructor(public pageService: AdmissionsEngagementsService) { }

	async ngOnInit() {
		await this.admissionsService.loadAdmissionsData();
	}


	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}
}